export default "__VITE_ASSET__Bd5XG5xh__"